// API

// region : User
// login API
export const loginApi = "/API/login";

// userList API
export const userListApi = "/API/UserList";
// UpdateUserApi
export const UpdateUserApi = "/API/UpdateUser";

// region : Factory
// factoryList API
export const factoryListApi = "/API/factoryList";

//createFactory API
export const createFactoryApi = "/API/createFactory";

//updateFactory API
export const updateFactoryApi = "/API/updateFactory";

//deleteFactory API
export const deleteFactoryApi = "/API/deleteFactory";


// region : Project
// projectList API
export const projectListApi = "/API/projectList";

// myProject API
export const myProjectApi = "/API/GetProject/";

// getEditProjectApi
export const getEditProjectApi = "/API/GetEditProject";

// deleteProjectApi
export const deleteProjectApi = "/API/DeleteProject";

// createProjectApi
export const createProjectApi = "/API/CreateProject";

// UpdateProjectApi
export const UpdateProjectApi = "/API/UpdateProject";

// GetReferenceProject API
export const getReferenceProjectApi = "/API/GetReferenceProject";


// region : CheckList
// getCheckListApi
export const getCheckListApi = "/API/FieldCheckList";

// getCheckListApi
export const getFieldCheckApi = "/API/GetFieldCheck";

// deleteFieldCheckApi
export const deleteFieldCheckApi = "/API/DeleteFieldCheck";

// updateFieldCheckApi
export const updateFieldCheckApi = "/API/UpdateFieldCheck";

// createFieldCheckApi
export const createFieldCheckApi = "/API/CreateFieldCheck";

// fieldCheckReferenceListApi
export const fieldCheckReferenceListApi = "/API/FieldCheckReferenceList";


// region : ItemReview
// itemReviewListApi
export const itemReviewListApi = "/API/ItemReviewList";

// createItemReviewApi
export const createItemReviewApi = "/API/CreateItemReview";

// updateItemReviewApi
export const updateItemReviewApi = "/API/UpdateItemReview";

// deleteItemReviewApi
export const deleteItemReviewApi = "/API/DeleteItemReview";


// region : Others
// getQuotationListApi
export const getQuotationListApi = "/API/SearchItemValues";

// AddCopiedCountApi
export const AddCopiedCountApi = "/API/AddCopiedCount";

// updateContainerValueApi
export const updateContainerValueApi = "/API/updateContainerValue";

// updateContainerApi
export const updateContainerApi = "/API/updateContainer";

// updateContainerAllApi
export const updateContainerAllApi = "/API/updateContainerAll";
